module.exports = __webpack_public_path__ + "img/will-executors.b90fc66d.svg";